import React from "react";

export default function Empty() {
  return (
    <div className="cardSection">
      <p className="byline -secondary _alignCenter">No Contacts Added</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/features/contacts/components/Empty.js